import type { WhoIsWovarAndWhyWovarSlice } from "~/lib/prismic";
import type { SliceComponentProps } from "@commercekit/prismic";
import DuoContent from "./variations/DuoContent";

const WhoIsWovarAndWhyWovar = ({
  slice,
}: SliceComponentProps<WhoIsWovarAndWhyWovarSlice>) => {
  switch (slice.variation) {
    case "duoContent": {
      return <DuoContent slice={slice} />;
    }
    default:
      return <div className="hidden">WHY WOVAR AND WHO WOVAR IS</div>;
  }
};

export default WhoIsWovarAndWhyWovar;
